import { ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';

import { routes } from './app.routes';
import { jwtInterceptor } from './core/auth/jwt.interceptor';
import { problemDetailsInterceptor } from './core/error-handling/problem-details.interceptor';
import { GlobalErrorHandler } from './core/error-handling/global-error-handler';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([jwtInterceptor, problemDetailsInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          // Class-based, not the default 'system' (media-query) selector, so ThemeService
          // can persist an explicit agent choice rather than only follow the OS -- see
          // ThemeService's own remarks. Kept in lockstep with Tailwind's own `dark:` variant
          // (styles.css's @custom-variant), so both styling systems flip together.
          darkModeSelector: '.dark',
        },
      },
    }),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ],
};
